import {Button} from 'antd';
import React, {FC} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';

import {IForecastCommentsCommentModal} from '../../model/types';

export const ForecastCommentsCommentModal: FC<IForecastCommentsCommentModal> = ({
    comment,
    title,
}: IForecastCommentsCommentModal) => (
    <>
        {comment && (
            <ModalOpenerComponent
                component={<Button type="default">Посмотреть</Button>}
                controlsStyle={{marginTop: '20px'}}
                modalProps={{title, centered: true}}
                controlLabels={{cancel: 'Закрыть'}}
            >
                {comment}
            </ModalOpenerComponent>
        )}
    </>
);

ForecastCommentsCommentModal.displayName = 'ForecastCommentsCommentModal';
